import React, { ElementType } from 'react'

import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import { SxProps } from '@mui/material/styles'

import { useEvent } from '../context'

interface ListItemWrapperProps {
  clickEventName?: string
  component?: ElementType
  onClick?: () => void
  sx?: SxProps
}

export const ListItemWrapper: React.FC<React.PropsWithChildren<ListItemWrapperProps>> = ({
  children,
  clickEventName,
  component,
  onClick,
  sx = {},
}) => {
  const { onEvent } = useEvent()

  if (onClick) {
    return (
      <ListItem
        className="list-wrapper"
        {...(component && { component })}
        sx={{ bgcolor: 'background.paper', ...sx }}
      >
        <ListItemButton
          onClick={() => {
            if (clickEventName) {
              onEvent(clickEventName)
            }
            onClick()
          }}
        >
          {children}
        </ListItemButton>
      </ListItem>
    )
  } else {
    return (
      <ListItem
        className="list-wrapper"
        {...(component && { component })}
        disableGutters={false}
        disablePadding={false}
        sx={{ bgcolor: 'background.paper', ...sx }}
      >
        {children}
      </ListItem>
    )
  }
}
